import { useState, useEffect, useMemo } from "react";
import { fetchTeam } from "../services/fetchTeam";

export const useTeam = () => {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTeam = async () => {
      try {
        setLoading(true);
        const data = await fetchTeam();
        setTeam(Array.isArray(data) ? data : (data.employees || []));
      } catch (err) {
        console.error("Failed to fetch team:", err);
      } finally {
        setLoading(false);
      }
    };
    loadTeam();
  }, []);

  const salesExecs = useMemo(() => {
    return (team || []).filter(u => {
      const r = (u.role || "").toLowerCase().trim().replace(/[-_\s]+/g, "-");
      return r === "sales-exec" || r === "sale-exec" || r === "sales-executive";
    });
  }, [team]);

  const projectManagers = useMemo(() => {
    return (team || []).filter(u => {
      const r = (u.role || "").toLowerCase().trim().replace(/[-_\s]+/g, "-");
      return r === 'designer' || r === "pm";
    });
  }, [team]);

  const getFilteredSalesExecs = (officeLocation) => {
    if (!officeLocation) return salesExecs;
    return salesExecs.filter(u => 
      (u.workLocation || "").toLowerCase().trim() === officeLocation.toLowerCase().trim()
    );
  };

  return { 
    team, 
    salesExecs, 
    projectManagers, 
    getFilteredSalesExecs,
    loading 
  };
};
